import Button from 'react-bootstrap/Button'
import { restoreDefaultProps } from '.'

// Button's `variant` (from defaultProps) sets its btn-primary styling.
restoreDefaultProps(Button)
